const CourseRouter = [
  {
    path: '/course/classRoom/:id', // 明細
    name: 'CourseDetailed',
    component: () => import('../../views/Course/CourseDetailed.vue'),
    meta: {
      title: 'route.title.buyCourse', // 購買課程
      layout: 'mainframe',
      haveTitle: true, // 標題
      haveBreadcrumb: false, // 麵包屑
      keepAlive: false, // 缓存
      needAuthority: false, // 權限
      isBack: false,
    },
  },
];

export default CourseRouter;
